"use client";

import { useEffect } from "react";
import { useSession } from "@/lib/session";
import { setInboxClient } from "@/lib/inbox";
import { syncSubscription } from "@/lib/push";

/**
 * Mounted once in the shell (montanhas-web#13): when a client is known, the bell's count
 * follows them and this browser's subscription is handed to public-api again, which
 * stamps the device seen. Draws nothing.
 */
export function NotificationsSync() {
  const { client, ready } = useSession();
  const clientId = client?.id ?? null;

  useEffect(() => {
    if (!ready) return;
    setInboxClient(clientId);
    if (clientId) void syncSubscription(clientId);
  }, [ready, clientId]);

  return null;
}
